import React from "react"
import {useOktaAuth} from "@okta/okta-react"
import {LoadingPage} from "@indebted/components/Loading"
import {toRelativeUrl} from "@okta/okta-auth-js"

function SecureRoute({component: Component, ...routeProps}) {
	const {oktaAuth, authState} = useOktaAuth()

	if (!authState) {
		return <LoadingPage />
	}

	if (!authState.isAuthenticated) {
		const originalUri = toRelativeUrl(window.location.href, window.location.origin)
		oktaAuth.setOriginalUri(originalUri)
		oktaAuth.signInWithRedirect()
		return <LoadingPage />
	}

	return <Component {...routeProps} />
}

export {SecureRoute}
